import SkeletonLoader from '@/components/SkeletonLoader';

interface ILessonBreakdownCardsSkeletonProps {
  count?: number;
}

const LessonBreakdownCardsSkeleton = ({
  count = 8,
}: ILessonBreakdownCardsSkeletonProps) => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(count)].map((_, i) => (
          <div
            key={i}
            className="border border-neutral-200 rounded-2xl p-4 flex items-center"
          >
            <div className="flex items-center justify-between w-full">
              {/* Left: title + subtitle */}
              <div className="flex flex-col gap-1.5">
                <SkeletonLoader width={120} height={18} />
                <SkeletonLoader width={80} height={14} />
              </div>
              {/* Right: status badge */}
              <SkeletonLoader width={72} height={24} className="rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonBreakdownCardsSkeleton;
